var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarship(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 650 390",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m448 224c17.652-0.020508 31.98-14.348 32-32 0-17.661-14.339-32-32-32s-32 14.339-32 32 14.339 32 32 32zm-208 96c0-17.661-14.339-32-32-32h-48l48.248-50.887 20.781 1.8887c-3.29-15.198-5.0234-30.676-5.0234-46.852 0-16.178 1.7334-31.953 5.0234-47.151l-20.779 1.8887-70.488-50.887h70.238c17.661 0 32-14.339 32-32s-14.339-32-32-32h-184c-13.246 9.7656e-4 -23.999 10.754-24 24v16c0 13.246 10.754 24 24 24h40l77.562 56.949-10.797 0.98242c-19.461 1.7695-34.728 18.152-34.728 38.07 0 19.919 15.267 36.299 34.728 38.068l10.795 0.98047-55.322 56.949h-62.238c-13.246 9.7656e-4 -23.999 10.754-24 24v16c0 13.246 10.754 24 24 24h184c17.661 0 32-14.339 32-32zm208 64c106.04 0 192-85.961 192-192s-85.961-192-192-192-192 85.961-192 192 85.961 192 192 192zm0-256c35.304 0.040039 63.96 28.696 64 64 0 35.322-28.678 64-64 64s-64-28.678-64-64 28.678-64 64-64z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarship);
export default __webpack_public_path__ + "static/media/starship.928db5d977069a3ac4d8bb50f012912f.svg";
export { ForwardRef as ReactComponent };